import styled from '@emotion/styled'

export const CardTitleStyled = styled.div({
  backgroundColor: '#e8e8e8',
  color: '#552d6b',
  fontWeight: 'bold',
  padding: '0.5em 1em',

  '.winprice': {
    color: '#000',
    fontWeight: 'normal',
  },
})

export const SpeedMapWrapperStyled = styled.div({
  '.length': {
    width: '3em',
    textAlign: 'center',

    '.lengthLead': { backgroundColor: '#111', color: '#fff', display: 'block' },
    '.lengthNormal': { backgroundColor: '#ccc', color: '#111', display: 'block' },
    '.lengthScratched': { color: '#f00' },
  },

  '.scratchedAcceptorText': { color: '#a9a9a9' },
  '.leadingText, .followingText': { color: '#111', fontSize: '24px' },
  '.visualMap': { width: '100%' },

  '.thoroughbredsMap': {
    '.visualMap': { background: '#518e48', fill: '#542c1c' },
    '.track': { fill: '#5c9c52' },
    '.rail': { stroke: '#81ab7a' },
    '.shadow': { fill: '#3e7834' },
    '.lengthName': { fill: '#fff' },
    '.silhouette': { stroke: '#5c9c52' },
  },

  '.trotsMap': {
    '.visualMap': { background: '#a69372' },
    '.track': { fill: '#b4a386' },
    '.rail': { stroke: '#bcae97' },
    '.shadow': { fill: 'rgba(0, 0, 0, 0.33)' },
    '.lengthName': { fill: ' #fff' },
    '.silhouette': { stroke: '#b4a386' },
  },

  '.dogsMap': {
    '.visualMap': { background: '#a69372' },
    '.track': { fill: '#b4a386' },
    '.rail': { stroke: '#bcae97', strokeWidth: 4, fill: 'none' },
    '.firstSection': { fill: '#fff', fontSize: '23px' },
    '.firstSectionLine': { stroke: '#927f5c', strokeWidth: 4 },
    '.jumpLabelBackground': { fill: '#927f5c' },
    '.jumpLabelText': { fill: '#fff', fontSize: '35px' },
    '.laneLine': { stroke: '#8e7b58', strokeWidth: 2 },
    '.shadow': { fill: '#7f6b47' },
    '.dog': { fill: '#fff' },
    '.acceptorNumberChevron': { fill: '#000', stroke: '#fff', strokeMiterlimit: 10 },
    '.acceptorNumberText': { fill: '#fff', textAnchor: 'middle', fontSize: '24px' },
    '.jumpDirectionBackground': { fill: '#615032' },
    '.jumpDirectionArrow': { fill: '#fff' },
    '.runLineText': { fill: '#413622', fontSize: '23px', textAnchor: 'middle' },
    '.scratchedText': { fill: '#f00', fontWeight: 'bold' },
    '.scratchedBox': { fill: '#fff' },
  },
})
